import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { GetExchangedToken, GetRefreshToken } from "../services/Sso";
import { SSO_ActionTypes, SSO_Refresh_ActionTypes } from "../models/DispatchTypes/Sso";
import { SSO_ActionDispatchTypes, SSO_Refresh_Token_ActionDispatchTypes } from "../constants/Sso";
import { baseUrl } from "../constants/Config";
import { ExchangeCodePayload } from "../models/Sso";

export const getExchangedToken: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    SSO_ActionTypes
  >
> = (payload: ExchangeCodePayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: SSO_ActionDispatchTypes.SSO_INVOKE,
    });
    const response = await GetExchangedToken(baseUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: SSO_ActionDispatchTypes.SSO_ERROR,
          });
          break;
        case 200:
        case 201:
          if ("data" in response) {
            dispatch({
              response: response.data,
              type: SSO_ActionDispatchTypes.SSO_SUCCESS,
            });
          }
          break;
        default:
          break;
      }
    }
  };
};

export const getRefreshedToken: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    SSO_Refresh_ActionTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: SSO_Refresh_Token_ActionDispatchTypes.SSO_REFRESH_TOKEN_INVOKE,
    });
    const response = await GetRefreshToken(baseUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: SSO_Refresh_Token_ActionDispatchTypes.SSO_REFRESH_TOKEN_ERROR,
          });
          break;
        case 200:
        case 201:
          if ("data" in response) {
            dispatch({
              response: response.data,
              type: SSO_Refresh_Token_ActionDispatchTypes.SSO_REFRESH_TOKEN_SUCCESS,
            });
          }
          break;
        default:
          break;
      }
    }
  };
};